import React from "react";

function ConfirmBox(_ref) {
  var a = _ref.children,
      b = _ref.options,
      c = _ref.isOpen,
      d = _ref.onClose,
      e = _ref.onConfirm,
      f = _ref.onCancel;
  return React.createElement("div", {
    className: "confirm-box-container",
    style: {
      display: c ? "block" : "none"
    }
  }, React.createElement("div", {
    className: "confirm-box-content"
  }, React.createElement("div", {
    className: "confirm-box flipInX"
  }, React.createElement("div", {
    className: "confirm-box-header"
  }, a ? a : React.createElement(React.Fragment, null, React.createElement("img", {
    src: b.icon,
    alt: "icon",
    width: "80"
  }), React.createElement("p", null, b.text))), React.createElement("span", {
    className: "confirm-box-close",
    onClick: d
  }, "\xD7"), b.btn && React.createElement("div", {
    className: "confirm-btn"
  }, React.createElement("button", {
    onClick: e
  }, b.confirm), React.createElement("button", {
    onClick: f
  }, b.cancel)))));
}

export default ConfirmBox;